module.exports = __webpack_public_path__ + "static/media/con_pickles.04c2dabf.gif";